if (!customElements.get('full-video')) {
    customElements.define('full-video', class Section5050 extends HTMLElement {
      constructor() {
          super();
      }
  
      connectedCallback() {            
          this.handleVideoPlay();
      }

      handleVideoPlay() {
          // Select the play button and video elements within this custom element
          const playButton = this.querySelector('.full-video__play');
          const video1 = this.querySelector('.full-video video');
          const video = this.querySelector('.full-video');
          const videoHeadline = this.querySelector('.full-video__headline');
      
          if (playButton && video) {      
              // Add an event listener to the video element to toggle play/pause, remove it after the first click
              video.addEventListener('click', () => {
                  if (video1.paused) {                
                      video1.play();
                      video1.controls = true;
                      playButton.style.display = "none";
                      if(videoHeadline){
                        videoHeadline.style.display = "none";
                      }
                  } else {
                      video1.pause();
                  }
              }, { once: true });
          }
        }
    });
  };